module.exports = __webpack_public_path__ + "media/pricing/Hazard_Tracking-ad8b8835.svg";